import type { RemoteAudioVideoComponentProps } from '../../core/types';

export function ZoomRemoteAudioVideo({ remoteParticipantId, videoRef }: RemoteAudioVideoComponentProps) {
  return <video-player class='fs-exclude' data-testid={`remote-video:${remoteParticipantId}`} ref={videoRef} />;
}
